module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fb-Gd-Hc-Ia.c7e10279.png";